import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

interface ImageCarouselProps {
  images: string[];
  getImageUrl: (name: string) => string;
  autoplay?: boolean;
  autoplayDelay?: number;
  effect?: 'slide' | 'fade';
  className?: string;
}

export default function ImageCarousel({
  images,
  getImageUrl,
  autoplay = true,
  autoplayDelay = 5000,
  effect = 'slide',
  className = '',
}: ImageCarouselProps) {
  if (images.length === 0) {
    return (
      <div className={`w-full h-[60vh] md:h-[70vh] placeholder-image ${className}`}>
        <div className="text-center">
          <svg
            className="w-16 h-16 mx-auto mb-4 text-milan-gray"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <p className="text-milan-gray">No images uploaded yet</p>
        </div>
      </div>
    );
  }

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay, EffectFade]}
      navigation
      pagination={{ clickable: true }}
      autoplay={autoplay ? { delay: autoplayDelay, disableOnInteraction: false } : false}
      effect={effect}
      loop={images.length > 1}
      className={`w-full h-[60vh] md:h-[70vh] lg:h-[80vh] ${className}`}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img
            src={getImageUrl(image)}
            alt={`Slide ${index + 1}`}
            className="w-full h-full object-cover"
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
